import "./App.css";
import Contact from "./components/Contact";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Pricing from "./components/Pricing";
import Services from "./components/Services";
import Trainers from "./components/Trainers";

function App() {
  return (
    <div>
      <Header />
      <Hero />
      <Services />
      <Pricing />
      <Trainers />
      <Contact />
    </div>
  );
}

export default App;